import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, StarHalf, Quote, MapPin, Check, ChevronRight } from "lucide-react";

const REVIEWS = [
  {
    name: "Sarah Thompson",
    location: "Cardiff to Newport",
    service: "House Removal",
    text: "Absolutely brilliant service! The team were punctual, careful with all our belongings, and made what could have been a stressful day completely stress-free. They even put our furniture exactly where we wanted it.",
    rating: 5,
    verified: true,
    date: "2 weeks ago",
  },
  {
    name: "James Mitchell",
    location: "London EC2",
    service: "Office Removal",
    text: "Used Hitech Transit for our office relocation. They worked over the weekend to minimize disruption. Everything was labelled, tracked, and set up in the new office by Monday morning. Highly professional throughout.",
    rating: 5,
    verified: true,
    date: "1 month ago",
  },
  {
    name: "Emma Williams",
    location: "Swansea to Cardiff",
    service: "Specialist Move",
    text: "Moved my elderly mother's house contents including antique furniture and a baby grand piano. They treated everything with such care — wrapped, padded, and delivered without a scratch. Can't recommend enough!",
    rating: 5,
    verified: true,
    date: "3 weeks ago",
  },
  {
    name: "David Roberts",
    location: "Cardiff CF10",
    service: "Storage + Move",
    text: "Needed to store our things for 6 weeks between selling and buying. Hitech handled the whole process — packed, stored, then delivered to our new place. Seamless. Worth every penny.",
    rating: 4.5,
    verified: true,
    date: "1 month ago",
  },
];

export const TestimonialsSection = () => (
  <section className="section-padding bg-[#0F172A]" data-testid="testimonials-section">
    <div className="container-max">
      <div className="text-center mb-14">
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FF5A1F] mb-2 block">Real Reviews From Real Customers</span>
        <h2 className="text-3xl md:text-4xl font-['Outfit'] font-bold tracking-tight text-white mt-2">
          Don't Take Our Word For It
        </h2>
        <div className="flex items-center justify-center gap-2 mt-4">
          <div className="flex">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className="w-5 h-5 fill-[#FF5A1F] text-[#FF5A1F]" />
            ))}
          </div>
          <span className="text-white/80 text-sm font-medium">4.9/5 from 500+ reviews</span>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {REVIEWS.map((review, index) => (
          <motion.div
            key={review.name}
            className="bg-white/[0.06] border border-white/10 p-6 hover:bg-white/[0.08] transition-colors"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.08 }}
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="flex items-center gap-1 mb-1">
                  {Array.from({ length: Math.floor(review.rating) }).map((_, i) => (
                    <Star key={`s-${i}`} className="w-4 h-4 fill-[#FF5A1F] text-[#FF5A1F]" />
                  ))}
                  {review.rating % 1 !== 0 && (
                    <StarHalf className="w-4 h-4 fill-[#FF5A1F] text-[#FF5A1F]" />
                  )}
                </div>
                <span className="text-xs text-white/40">{review.date}</span>
              </div>
              {review.verified && (
                <span className="flex items-center gap-1 text-xs text-green-400 bg-green-400/10 px-2 py-1">
                  <Check className="w-3 h-3" /> Verified
                </span>
              )}
            </div>

            <Quote className="w-6 h-6 text-[#FF5A1F]/40 mb-3" />
            <p className="text-white/85 leading-relaxed text-sm mb-5">
              "{review.text}"
            </p>

            <div className="flex items-center justify-between border-t border-white/10 pt-4">
              <div>
                <div className="font-semibold text-white text-sm">{review.name}</div>
                <div className="flex items-center gap-1 text-xs text-white/50">
                  <MapPin className="w-3 h-3" /> {review.location}
                </div>
              </div>
              <span className="text-xs bg-white/10 text-white/70 px-2 py-1">
                {review.service}
              </span>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link
          to="/reviews"
          className="text-[#FF5A1F] font-semibold inline-flex items-center gap-1 hover:gap-2 transition-all text-sm"
          data-testid="read-more-reviews-link"
        >
          Read All 500+ Reviews <ChevronRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);
